module.exports = __webpack_public_path__ + "img/af.855c9dc1.svg";